// extracted by mini-css-extract-plugin
export default {"error":"ErrorUi_error__HMWL6","fadeIn":"ErrorUi_fadeIn__zVWvZ","button":"ErrorUi_button__rw04N"};